import { Stack } from '@cowbell/ui';
import { NudgeCard } from './NudgeCard';
import { useNudges } from './nudgeStore';
import styles from './NudgeStack.module.css';

/**
 * Stacks active nudges as separate cards (oldest on top) near the Ask Moo
 * launcher — no merging; each keeps its own title bar and the stack grows.
 */
export function NudgeStack() {
  const nudges = useNudges();
  if (nudges.length === 0) return null;

  return (
    <div className={styles.container}>
      <Stack gap="sm">
        {nudges.map((n) => (
          <NudgeCard key={n.id} nudge={n} />
        ))}
      </Stack>
    </div>
  );
}
